if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// select all elements with class "button"
const additionalVarinats = document.querySelectorAll(".additional-variants");

// loop through each button
additionalVarinats.forEach((button) => {
  button.addEventListener("click", function (variant) {
    var ele = document.querySelectorAll(".product-form__input input");
    let currentUrl = window.location.href;
    let newUrl = currentUrl.split("?");
    let formId = document.querySelector(".product-variant-id");
    let mediaId = this.dataset.mediaId;
    let productTitle = document.querySelector(".product h1");
    let productImage = document.querySelector(".product__media-item--variant.is-active .product__media img");
    let productSku = document.querySelector(".product__sku");
    let productInventory = document.querySelector(".inventori-main .product__inventory");
    const mediaGalleries = document.querySelectorAll(".product__column-sticky");
    for (var i = 0; i < ele.length; i++) {
      ele[i].checked = false;
    }
    window.history.pushState(null, null, newUrl[0]);
    formId.value = this.dataset.variantId;
    productSku.innerHTML = this.dataset.sku;
    mediaGalleries.forEach((mediaGallery) => {
      let activeMedia = mediaGallery.querySelectorAll(
        ".product__media-list li"
      );
      activeMedia.forEach((mediaGalleryList) => {
        let activeMediaId = mediaGalleryList.dataset.mediaId;
        if (mediaId == activeMediaId) {
          mediaGallery.setActiveMedia(activeMediaId, true);
        }
        else
        {
          mediaGallery.setActiveMedia(activeMediaId, false);
        }
      });
    });
     productTitle.innerHTML = this.dataset.title;
     document.querySelector(".product__title h1").style.display = "block"; 
     document.querySelector(".product__title a").style.display = "none"; 
     console.log(this.dataset.availabilty);
     if(this.hasAttribute("data-availabilty")){
      document.querySelector(".product-sku-number").style.marginRight = "62px";
     productInventory.innerHTML = `<div class="product-code-3">Availibility</div>
                      <svg width="15" height="15" aria-hidden="true">
                        <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(238,148,65, 0.3)"></circle>
                        <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(238,148,65)"></circle>
                      </svg><span>${this.dataset.availabilty}</span></div>`;
     }
    else{
      productInventory.innerHTML = "";
    }
    let productPrice = this.querySelector(".custom-price").innerHTML;
    document.querySelector(".product-price-container").innerHTML = productPrice;
    let productDescription = this.querySelector(".custom-product-description").innerHTML;
    document.querySelector(".product__description").innerHTML = productDescription;
    let productIncludes = this.querySelector(".custom-product-includes").innerHTML;
    document.querySelector(".product__accordion .accordion__content").innerHTML = productIncludes;
  });
});
